import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

// Create Supabase client with minimal configuration to avoid conflicts
const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Enable automatic token refresh
    autoRefreshToken: true,
    // Persist session in localStorage  
    persistSession: true,
    // Detect session from URL fragments (for password reset, email confirmation)
    detectSessionInUrl: true
    // Let Supabase use its default storage implementation
  }
});

export default supabase;
